module.exports = __webpack_public_path__ + "media/luxury-2026/garden-pavilion-8a747b15.jpg";